import {
  FILE_DELETE_SUCCESS,
  FILE_SAVE,
  FILE_UPLOAD_SUCCESS,
  FILE_DOWNLOAD_NOTIFICATION,
  FILE_UPLOAD_NOTIFICATION,
  FILE_UPLOAD_ERROR,
  GET_FILES,
} from "../actions/types";

const initialState = {
  downloadFile: "",
  uploadFile: null,
  deleteFile: false,
  notification: false,
  notificationUpload: false,
  errorMessage: "",
  files: [],

  // when we fetch data takes some ms to get
};

//will later get state from api

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_FILES:
      console.log("glklkejljgljfg");
      return {
        ...state,
        files: action.payload,
      };

    case FILE_SAVE:
      return {
        ...state,
        downloadFile: action.payload,
      };
    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadFile: action.payload.uplFile,
      };
    case FILE_DELETE_SUCCESS:
      return {
        ...state,
        deleteFile: action.payload.deleteFile,
      };
    case FILE_DOWNLOAD_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    case FILE_UPLOAD_NOTIFICATION:
      return {
        ...state,
        notificationUpload: action.payload,
      };
    case FILE_UPLOAD_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}
